module.exports = __webpack_public_path__ + "img/Authenticity-heare.762604e1.png";